import _ from 'lodash';
import get from 'lodash/get';
import {
    R2H_LIVEBLOG_CONFIG_PATH
} from './route-to-hole-constants';
import {
    hasValue
} from '../../../general/js/general-helpers';

export const getLiveBlogRouteToHoleConfig = (shotTrackerConfig) => {
    if (!hasValue(shotTrackerConfig)){
        return {};
    }

    return get(shotTrackerConfig, R2H_LIVEBLOG_CONFIG_PATH, {});
};

export const formatVideoAssetSrc = (endpointUrl, entryId, extension) => {
    if(!hasValue(entryId) || !hasValue(endpointUrl) || !hasValue(extension)) return null;

    return `${endpointUrl}${entryId}${extension}`;
};

export const getR2hThumbnailSrc = (entryId = null, liveBlogR2HConfig = {}) => {
    if(!hasValue(entryId) || !hasValue(liveBlogR2HConfig)) return null;

    const { thumbnailUrl, thumbnailFormat } = liveBlogR2HConfig;

    return formatVideoAssetSrc(thumbnailUrl, entryId, thumbnailFormat);
}

export const getR2hVideoSrc = (entryId = null, liveBlogR2HConfig = {}) => {
    if(!hasValue(entryId) || !hasValue(liveBlogR2HConfig)) return null;

    const { videoUrl, videoFormat } = liveBlogR2HConfig;

    return formatVideoAssetSrc(videoUrl, entryId, videoFormat);
}



